module.exports = __webpack_public_path__ + "static/img/datablock.98f42849.png";